import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgAtsign = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M6.451 6.451C5.248 7.655 4.5 9.488 4.5 12s.748 4.345 1.951 5.549C7.655 18.752 9.488 19.5 12 19.5c1.107 0 2.083-.146 2.928-.41a1.5 1.5 0 1 1 .894 2.863c-1.17.366-2.453.547-3.822.547-3.113 0-5.78-.94-7.67-2.83S1.5 15.113 1.5 12s.94-5.78 2.83-7.67S8.887 1.5 12 1.5s5.78.94 7.67 2.83S22.5 8.887 22.5 12c0 1.924-.482 3.455-1.44 4.52-.971 1.078-2.254 1.48-3.435 1.48-.812 0-1.627-.188-2.324-.673a4 4 0 0 1-.29-.225c-1.813 1.234-3.854 1.592-5.642.88-2.325-.926-3.553-3.385-3.264-6.374C6.4 8.55 8.448 6.538 10.8 6.006c1.43-.324 2.969-.089 4.217.753a1.5 1.5 0 0 1 2.234 1.46l-.53 5.062c-.059.558-.017.94.054 1.185.074.257.172.352.239.398.079.055.254.136.61.136.507 0 .912-.16 1.206-.488.308-.342.67-1.06.67-2.512 0-2.512-.748-4.345-1.951-5.549C16.345 5.248 14.512 4.5 12 4.5s-4.345.748-5.549 1.951m7.594 3.573c-.572-.986-1.581-1.319-2.583-1.092-1.101.25-2.202 1.208-2.371 2.965-.198 2.046.63 2.996 1.388 3.298.72.287 1.92.215 3.238-.863a7 7 0 0 1 .02-1.363z'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgAtsign)
export default ForwardRef
